import { roundToTwoDecimals } from 'utils/number'
import { EnergyType, GenericServiceContract } from '@boltenergy-be/shared'

/**
 * Adds the given newInstalment to the given contract
 *
 * @template ET
 * @param {GenericServiceContract<ET>} contract
 * @param {number} newInstalment
 * @returns {GenericServiceContract<ET>}
 */
export const addNewInstalmentToContract = <ET extends EnergyType>(
  contract: GenericServiceContract<ET>,
  newInstalment: number
): GenericServiceContract<ET> => {
  return {
    ...contract,
    detail: {
      ...contract.detail,
      instalment: Number(roundToTwoDecimals(newInstalment))
    }
  }
}
